/** Modulo Prato (140) — codigos em contracts/enums.yaml */
export const PRATO_ACAO = {
  CRIAR: 1401,
  ATUALIZAR: 1402,
  REMOVER: 1403,
} as const;

export const PRATO_ACOES_MODULO = [PRATO_ACAO.CRIAR, PRATO_ACAO.ATUALIZAR, PRATO_ACAO.REMOVER] as const;
